import React from "react";
import PropTypes from "prop-types";

import styles from "./reviews.module.scss";

function Review({
  onClick,
  content: {photo, author, date, comments, orderedProducts}
}) {
  function createMarkup(html) {
    return {__html: html};
  }
  return (
    <div className={styles.review}>
      {photo && (
        <a href="#" className={styles.reviewPhoto} onClick={onClick}>
          <div
            className={styles.photo}
            style={{backgroundImage: `url(${photo})`}}
          />
        </a>
      )}
      <div className={styles.reviewContent}>
        <div className={styles.reviewHeader}>
          <span className={styles.author}>{author}</span>
          <span className={styles.date}>{date}</span>
          <div className={styles.order}>
            <span>В заказе: </span>
            <span dangerouslySetInnerHTML={createMarkup(orderedProducts)} />
          </div>
        </div>
        <div className={styles.reivewComments}>{comments}</div>
      </div>
    </div>
  );
}

Review.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.number,
    author: PropTypes.string,
    scores: PropTypes.shape({
      productQuality: PropTypes.number,
      printQuality: PropTypes.number,
      serviceLevel: PropTypes.number
    }),
    photo: PropTypes.string,
    date: PropTypes.string,
    comments: PropTypes.string,
    answer: PropTypes.string,
    orderedProducts: PropTypes.string,
    orderPath: PropTypes.string
  }),
  onClick: PropTypes.func
};

export default Review;
